//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'

export default {
  mixins: [seo],
  data () {
    return {
      australia: {
        image: 'Australia.webp',
        country: 'Australia',
        name: 'MoTeC Pty Ltd',
        address: '1555 Centre Road, Clayton, Victoria 3168, Australia',
        generalPhone: '+61 3 9761 5050',
        generalEmail: 'admin@motec.com.au',
        supportPhone: '+61 3 9761 5050',
        supportEmail: 'support@motec.com.au',
        webIssuesEmail: 'webmaster@motec.com.au'
      },
      europe: {
        image: 'Europe.webp',
        country: 'Europe',
        name: 'MoTeC Europe Ltd.',
        address: 'Unit 14, Twyford Mill Industrial Estate,',
        address2: 'Oxford Road, Adderbury (near Banbury),',
        address3: 'Oxfordshire OX17 3SX',
        generalPhone: '+44 8700 119 100',
        generalEmail: 'sales@moteceurope.co.uk',
        supportPhone: '+44 8700 119 100',
        supportEmail: 'support@moteceurope.co.uk'
      }
    }
  },
  created () {
    this.seoTitle = 'Contact Us'
  }
}

